import React, {lazy, Suspense, useEffect}from "react";
import {Grid, withWidth} from "@material-ui/core";
import { Alert, AlertTitle } from '@material-ui/lab';
import { AuthState } from "../../../../modules/redux/Auth/reducer";
import { Spinner, SpinnerSize, Text } from "office-ui-fabric-react";
import Blueprints from "../../../../assert/images/ManageX_new.svg";
import Requestbg from "../../../../assert/images/request-button.svg";
import { useDispatch } from "react-redux";
import { AuthActions } from "../../../../modules/redux";
import { DeployButton } from "../../../../styles";
import landingpageImg from "../../../../assert/images/landingpageImg_new.svg";
import ResearchpageImg from "../../../../assert/images/ResearchpageImg_new.svg";
import { GetAdminEmail } from "../../../../const";

function alertMessageHTML(severity, title, message, props, dispatch) {
    setTimeout(
        function () {
            props.setDisableError(true);
            dispatch(AuthActions.logout(""));
            props.setShowRequestTrialMessage(false);
        },
        7000
    );
    
    return (!props.disableError? <Alert severity={severity} style={{ backgroundColor: "#118F7D", opacity: 0.7, color:"white"}}>
        <AlertTitle>{title}</AlertTitle>
        {message}
    </Alert>:<></>);
}

const Footer = lazy(() => import('./footer'));
const Description = lazy(() => import('./description'));

function Content(props){
    const dispatch = useDispatch();

    const [adminEmail, setAdminEmail] = React.useState("");

    useEffect(() => {
        GetAdminEmail().then(res => {
            setAdminEmail(res.data.data.email);
        })
    }, []);

   return ( <React.Fragment>
       <div style={{ marginTop: props.width === "xs" || props.width === "sm"? 50 :60 }}>
           <div className={props.classes.landingPageContent} >
               {
                   props.showRequestTrailMessage? alertMessageHTML(
                       !props.loginRequestStatus? "error" :"success",
                       !props.loginRequestStatus ? "Request Trial Error" : "Request Trial Success",
                       props.loginErrorMessage,
                       props,
                       dispatch
                   ) : <div />
               }
                {
                    props.auth.state === AuthState.LOGIN_ERROR?
                        alertMessageHTML(
                                        "error",
                                        "Login Error", 
                                        props.loginErrorMessage,
                            props,
                            dispatch
                                ) : <div />
                }

                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "10px 50px 50px 50px" }}
                >
                   <Grid item xs={props.width === "xs" ? 12 : 6} sm={6} >
                       {
                           props.pathUrl === "/" ?
                               <>
                                   <Text style={{ color: "#fff", fontSize: '35px', fontWeight: 500, lineHeight: '140%', }}>ManageX</Text><br />
                                   <div className={props.classes.landingPageHeadParagraphHolder}>
                                       <div className={props.classes.landingPageHeadParagraph}>
                                           Users can submit custom Blueprints that are published and made available by our Operations Team to share with others in the organization
                                       </div>
                                   </div>
                               </> :
                               props.pathUrl === "/hpc/i" ?
                                    <>
                                        <Text style={{ color: "#fff", fontSize: '35px', fontWeight: 500, lineHeight: '140%', }}>The Power of </Text>
                                        <Text style={{ fontSize: '35px', fontWeight: 500, lineHeight: '140%', color: "#14E2C5" }}>HPC <br /> made simple </Text>
                                        <div className={props.classes.landingPageHeadParagraphHolder}>
                                            <div className={props.classes.landingPageHeadParagraph}>
                                                Get all the advantages of HPC without the cost of development, deployment, use, and management with ManageX, your HPC solution in the cloud.
                                            </div>
                                        </div>
                                   </> :
                                   <>
                                       <Text style={{ color: "#fff", fontSize: '35px', fontWeight: 500, lineHeight: '140%', }}>Academic <br/> researchers face a <br/> common problem </Text>                                      
                                       <div className={props.classes.landingPageHeadParagraphHolder}>
                                           <div className={props.classes.landingPageHeadParagraph}>
                                               Dealing with the intricacies of IT infrastructure distracts them from doing their research. This applies to researchers at all levels who need to make use of Azure to conduct their research.
                                           </div>
                                       </div>
                                   </>

                       }
                      
                       <DeployButton
                           style={{
                               marginTop: 15,
                               backgroundColor: "#14e2c5",
                               backgroundImage: `url(${Requestbg})`,
                               backgroundPosition: 'center',
                               padding:20,
                           }} onClick={() => { props.handleMenuClick("requestTrail"); }}>
                           <Text style={{ fontSize: 12, color: "#000", fontWeight:500 }}> Request Trial</Text>
                       </DeployButton>
                   </Grid>
                   {
                       props.pathUrl === "/" ?
                           <Grid item xs={props.width === "xs" ? 12 : 6} style={{ paddingTop: 30 }}>
                               <img src={landingpageImg} alt={"LOGO"} width="100%" />
                           </Grid> :
                           props.pathUrl === "/hpc/i" ?
                               <Grid item xs={props.width === "xs" ? 12 : 6} style={{ paddingTop: 30 }}>
                                   <img src={Blueprints} alt={"LOGO"} width="100%" />
                               </Grid> :
                               <Grid item xs={props.width === "xs" ? 12 : 6} style={{ paddingTop: 30 }}>
                                   <img src={ResearchpageImg} alt={"LOGO"} width="100%" />
                               </Grid>

                   }
                    
                </Grid>

            </div>
            <div ref={props.benefit} style={{ paddingBottom: '20px'}}></div>
           <Suspense fallback={<Spinner styles={{ root: { marginTop: '15px' } }} size={SpinnerSize.medium} label="Loading...." ariaLive="assertive" labelPosition="right" />}>
               <Description {...props} pathUrl={props.pathUrl} />
            </Suspense>
        </div>

        <Suspense fallback={<Spinner styles={{ root: { marginTop: '15px' } }} size={SpinnerSize.medium} label="Loading...." ariaLive="assertive" labelPosition="right" />}>
           <Footer {...props} adminEmail={adminEmail}/>
        </Suspense>
    </React.Fragment>
);
            }

export default withWidth()(Content);